export const schedulingBookingsRoutePrefixes = [
  "/booking",
  "/book",
  "/biz/calendar",
  "/biz/printview",
  "/biz/bookingtypes",
  "/biz/create",
  "/biz/update",
  "/myschedule",
  "/b/:businessUrl/booking",
];
